import { useEffect, useRef, useState } from "react";
import { subscribeScroll, prefersReducedMotion } from "@/lib/scrollEngine";

/**
 * Returns a 0–1 progress value based on how far the element
 * has scrolled through the viewport.
 */
export function useScrollLinked(
  startAt = 0.8,   // element top at 80% of viewport → progress 0
  endAt = 0.2      // element top at 20% of viewport → progress 1
) {
  const ref = useRef<HTMLDivElement>(null);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    // Under reduced motion, reveal everything immediately (no scroll-linked move).
    if (prefersReducedMotion()) {
      setProgress(1);
      return;
    }

    return subscribeScroll(() => {
      const rect = el.getBoundingClientRect();
      const wh = window.innerHeight;
      const start = wh * startAt;
      const end = wh * endAt;
      const p = Math.min(Math.max((start - rect.top) / (start - end), 0), 1);
      setProgress(p);
    });
  }, [startAt, endAt]);

  return { ref, progress };
}
